import CryptoJS from 'crypto-js';

const KEY = "D4oxmY0uI7vbwRILv9aK9LrRQKmwzfWL";

const encryptMethod = (word) => {   
    var key = CryptoJS.enc.Base64.parse(KEY);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
   
    return encrypted.toString();
}

const encryptEmpfat = (filtro) =>{
    if(filtro.hasOwnProperty("empfat")) {            
        filtro.encryptedCodemp = encryptMethod(filtro.empfat);
        delete filtro.empfat;
    }
    return filtro;
}

export {encryptEmpfat, encryptMethod};